import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

export const Rich = ({ html, className, ...rest }) => (
  <div className={cn("rich-content", className)} dangerouslySetInnerHTML={{ __html: html || "" }} {...rest} />
);

export const Reveal = ({ children, delay = 0, className }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, className }) => (
  <p className={cn("text-xs font-bold uppercase tracking-[0.25em] text-brass", className)}>{children}</p>
);
